import React from "react";
import { Row, Col, Switch,Form } from "antd";

const UserDefaultPermission = ({ name="", defaultPermissionOnChange }) => {
  return (
    <div className="is_form_2_top_bar">
      <Row>
        <Col sm={12} xs={12} >
          <div style={{display:"flex", alignItems:"center"}}>
            {name ? <h3>{name}</h3> : null}
          </div>
        </Col>
        <Col sm={12} xs={12}>
          <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
            <label style={{marginRight:"10px"}}>Default Permission</label>
            <Form.Item
                      style={{
                        borderBottom: "none", 
                      }}
                      name="default_access"
                      valuePropName="checked"
                    >
            <Switch onChange={defaultPermissionOnChange} defaultChecked/>
            </Form.Item>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UserDefaultPermission;